import { jsonDateTimeReplacer, jsonDateTimeReviver } from './DateTime/Json';

export function undefinedToNullReplacer(this: any, key: string, value: unknown) {
    if (value === undefined) {
        return null;
    }
    return value;
}

export function nullToUndefinedReviver(key: string, value: unknown) {
    if (value === null) {
        return undefined;
    }

    return value;
}

export function combineReplacers(...revivers: ((this: any, key: string, value: unknown) => any)[]) {
    return function combinedReviver(this: any, key: string, value: unknown) {
        let returnValue = value;
        revivers.forEach(r => {
            returnValue = r.call(this, key, returnValue);
        });
        return returnValue;
    };
}

export const combineRevivers = (...revivers: ((key: string, value: unknown) => any)[]) => (key: string, value: unknown) => {
    let returnValue = value;
    revivers.forEach(r => {
        returnValue = r(key, returnValue);
    });
    return returnValue;
};

export const standardRevivers = combineRevivers(nullToUndefinedReviver, jsonDateTimeReviver);
export const standardReplacers = combineReplacers(undefinedToNullReplacer, jsonDateTimeReplacer);
